export default __webpack_public_path__ + "static/media/app-arm64-v8a-release.779ccfc7.apk";